import React from "react"
import { useStyles } from "./styles"
import circleLoader from "./CircleLoader.svg?url"

interface Props {
  iconSrc?: string
  dataAutomationId?: string
}

const CircleLoader: React.FC<Props> = ({ iconSrc, dataAutomationId }) => {
  const { classes } = useStyles()

  return (
    <img
      alt="Loading"
      src={iconSrc || circleLoader}
      className={classes.circleLoader}
      data-automation-id={dataAutomationId || "Loading"}
    />
  )
}

export default CircleLoader
